import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API;

const createAxiosInstance = (useAuth = false) => {
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (useAuth) {
    instance.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  return instance;
};

export const privateApi = createAxiosInstance(true);
export const publicApi = createAxiosInstance(false);
